import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import getOperatorTasks from './useOperatorTasks.request';
import { OPERATOR_TASKS_KEY } from './queryKeys';

import { LaunchpadItem } from 'modules/common/components/LaunchpadProgress/LaunchpadProgress.interface';

export interface UseOperatorTasksOptions
    extends Omit<
        UseQueryOptions<
            Record<string, Partial<LaunchpadItem>>,
            Error,
            Record<string, Partial<LaunchpadItem>>,
            (string | string[] | boolean)[]
        >,
        'queryKey'
    > {
    /**
     * When true, skips hardcoding task statuses as completed for certain tasks (e.g., middesk tasks).
     */
    skipHardcodedStatus?: boolean;
}

/**
 * This hook is to be used in the `useLaunchpadSchema` to get the tasks for the current user.
 * @param taskNames - The names of the tasks to get builded in the schema.
 * @param options - The options for the query.
 * @returns The tasks for the current user.
 */
export default function useOperatorTasks(taskNames: string[], options?: UseOperatorTasksOptions) {
    const { skipHardcodedStatus = false, ...queryOptions } = options ?? {};

    return useQuery({
        queryKey: [OPERATOR_TASKS_KEY, taskNames, skipHardcodedStatus],
        queryFn: () => getOperatorTasks(taskNames, skipHardcodedStatus),
        ...queryOptions,
    });
}
